import { SVGAttributes } from 'react';
import { Keys } from '../../../../patient-types';
import BodySelectButton from './BodySelectButton';

const LeftArmMaleButtons = ({
  selectedKeys,
  ...props
}: SVGAttributes<SVGElement> & {
  selectedKeys: Keys;
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={183}
      height={351}
      fill='none'
      {...props}
      style={{
        transform: 'scaleX(-1)',
      }}
    >
      <g clipPath='url(#a)'>
        <g clipPath='url(#b)'>
          <path
            fill='#F2F4FC'
            d='m87.362 341.751.09-1.703-10.029-6.97.469 3.413 9.47 5.26ZM110.368 162.832l18.524-55.5c-1.788.159-3.45.249-4.924.249-1.311 0-2.529-.092-3.465-.185-6.088-1.014-12.55-7.101-17.794-13.465.094 3.136.187 7.655.281 12.82.708 5.032 5.771 42.824 7.378 56.081Z'
          />
          <path
            fill='#F2F4FC'
            fillRule='evenodd'
            d='M129.242 105.056c-1.984.199-3.802.311-5.368.311-1.217 0-2.247 0-3.09-.184-6.181-1.015-19.199-16.417-19.199-16.417-2.465-3.367-3.31-11.455-3.68-15.005-.066-.631-.117-1.119-.16-1.411-.28-2.121 1.03-8.024 1.78-9.223a30.294 30.294 0 0 0-2.529 3.505l-.843 1.383-1.217-12.174-.75 15.31s1.874 13.742 6.088 19.737c.018 1.014.045 2.372.077 4.014.302 15.531 1.1 56.458-.171 71.889-2.06 24.902-8.896 48.604-14.984 69.448-4.027 13.926-7.492 26.008-8.803 35.877-.187 1.567.188 3.228 1.03 4.611 1.686 2.675 5.713 9.223 6.93 11.528.375.646.843 1.661 1.405 3.044v.277h.188c2.06 5.072 4.87 13.926 3.465 19.183l-.094.184v.185c.375 2.582 2.435 15.494 3.746 17.708 1.218 2.029 1.873 4.611 1.686 5.257-.375.369-2.06 1.106-4.027.922-1.78-.184-3.278-1.107-4.308-2.767-2.248-3.689-2.622-8.3-2.81-11.621l-.056-.597c-.155-1.645-.274-2.912-.693-3.737-1.217-2.306-2.81-3.321-2.997-3.413l-.843-.461-3.933 4.427c-1.405 1.476-1.967 3.413-1.686 5.349l2.248 15.495 11.144 5.902.281.092c1.03 1.199 2.435 3.136 2.154 4.151a.382.382 0 0 0-.063.101c-.065.129-.17.337-.592.544-7.68-2.49-19.854-7.47-21.353-10.883l-7.023-19.091 2.715 11.252c-2.433-4.074-5.077-8.286-6.228-10.12l-.42-.671c-.012-.294-.038-.807-.072-1.487-.243-4.864-.915-18.309.071-22.031.658-2.51.883-9.072 1.118-15.942.032-.955.065-1.916.1-2.872.187-5.903.374-11.529.749-13.373v-.185l.017-.301c.164-2.768 1.428-24.12.639-48.303-1.03-29.697 1.685-50.264 7.866-61.239 3.61-6.473 2.463-25.109 1.531-40.235l-.032-.53c-.469-6.272-.75-11.713-.656-14.664.094-2.583-.187-5.073-1.03-7.47-1.218-3.598-3.465-11.068-4.683-21.859-3.278-28.314 3.184-39.012 4.495-40.857.937-1.199 6.743-5.441 15.734-11.252 2.06-1.29 4.401-2.029 6.836-2.029 7.926-.061 23.128-.123 34.441-.102l5.859 90.82ZM69.557 66.539c.562 1.66 1.123 3.228 1.873 4.796l.28-.092c-.374-1.568-.749-3.228-1.03-4.888-.28-1.66-.561-3.32-.749-4.98-.374-3.32-.655-6.733-.655-10.053-.094-3.413.093-6.733.468-10.053.047-.415.117-.83.187-1.245.07-.415.14-.83.188-1.245l.187-1.2.187-1.29.562-2.398.375-1.291.28-1.2-.187-.092c-1.592 3.136-2.622 6.364-3.277 9.776-.656 3.413-.937 6.825-.937 10.238 0 3.504.375 6.917 1.03 10.237l.562 2.49c.187.83.375 1.66.656 2.49ZM123.5 87.936c.187-.184.374-.46.468-.738.187-.276.281-.553.093-.83-.093-.368-.187-.645-.374-.922-.375-.553-.937-.83-1.499-1.107-.561-.276-1.123-.46-1.685-.645-2.247-.646-4.683-.83-7.024-.922v.184c.317.156.999.275 1.838.422 2.136.374 5.289.926 6.029 2.714 1.685 4.058-4.964 4.611-7.399 1.199-.402-.566-1.052-.924-1.71-1.287-.414-.228-.831-.458-1.193-.742l-.187.092a16.2 16.2 0 0 0 2.247 2.767c.937.83 1.873 1.568 2.997 2.029.562.276 1.124.369 1.779.46.656 0 1.312 0 1.873-.184.562-.184 1.124-.46 1.686-.737.047-.046.117-.093.188-.139.07-.046.14-.092.187-.138.047-.046.117-.092.187-.138.07-.047.141-.093.187-.139.094-.092.211-.184.328-.276.117-.093.234-.185.328-.277a2.18 2.18 0 0 0 .656-.646Z'
            clipRule='evenodd'
          />
          <path
            fill='#F2F4FC'
            d='m123.242 12.059-.959-14.872c-8.766 5.46-18.743 11.282-26.785 14.938 8.161-.056 19.063-.078 27.744-.066Z'
          />
          <path
            fill='#C3C7D9'
            d='M120.69 83.602c.562.184 1.124.368 1.686.645.561.277 1.123.553 1.592 1.015.281.276.374.553.374.922 0 .276-.093.645-.187.922-.066.194-.178.343-.303.51a5.094 5.094 0 0 0-.165.228l-.656.646a4.117 4.117 0 0 1-.328.276c-.117.093-.234.185-.327.277-.047.046-.118.092-.188.138-.07.046-.14.093-.187.139-.047.046-.117.092-.187.138a1.274 1.274 0 0 0-.188.138c-.562.37-1.123.554-1.685.738-.656.184-1.218.277-1.873.185-.656-.093-1.218-.185-1.78-.462-1.124-.46-2.154-1.198-2.997-2.029a16.248 16.248 0 0 1-2.247-2.766l.187-.093c.364.261.752.476 1.13.685.691.383 1.349.748 1.773 1.344 2.435 3.413 8.991 2.86 7.399-1.199-.768-1.856-4.14-2.431-6.271-2.795-.727-.124-1.31-.223-1.596-.34v-.185c2.341.092 4.683.277 7.024.922ZM69.182 51.322c0 3.412.28 6.732.655 10.052.094.83.211 1.66.328 2.49.117.83.234 1.66.328 2.49.238 1.404.542 2.741.857 4.124l.173.765-.187.092c-.75-1.568-1.311-3.136-1.873-4.796a24.32 24.32 0 0 0-.328-1.245c-.117-.415-.234-.83-.328-1.245l-.562-2.49c-.655-3.412-1.03-6.825-1.03-10.237 0-3.413.281-6.825.937-10.238.655-3.412 1.685-6.732 3.278-9.776l.187.092-.281 1.2-.375 1.29-.562 2.398-.187 1.292-.187 1.199c-.188.83-.281 1.66-.375 2.49-.375 3.32-.468 6.733-.468 10.053Z'
          />
          <path
            fill='#C3C7D9'
            d='m88.553 351.059-.36-.089s-.094 0-.375-.092l.003.032a20.833 20.833 0 0 1-2.248-.65l-.002-.027c-.382-.144-.796-.297-1.236-.461a2.198 2.198 0 0 1-.033-.015l-.001.002c-1.82-.676-4.085-1.518-6.41-2.478-7.398-3.135-11.612-5.902-12.642-8.392-1.947-4.393-8.667-15.008-10.496-17.896-.283-.448-.449-.71-.462-.735l-.187-.276v-.277c-.094-.83-1.311-19.644 0-24.533.656-2.582.937-10.882 1.124-18.261.187-6.179.374-11.62.75-13.649.093-1.384 1.404-23.334.655-48.328-1.03-30.527 1.685-51.002 8.147-62.438 3.372-5.903 2.154-25.363 1.218-39.474l-.15-2.525c-.317-5.286-.587-9.783-.506-12.416.094-2.305-.187-4.519-.936-6.64-1.218-3.597-3.465-11.344-4.777-22.32-3.37-28.498 2.904-39.657 4.87-42.424 1.124-1.568 6.556-5.534 16.296-11.805a15 15 0 0 1 8.147-2.398h.468c8.567-3.09 21.583-10.64 32.527-17.477l.16 2.285c-8.721 5.427-18.614 11.193-26.6 14.823 8.127-.055 18.97-.078 27.632-.067l.152 2.178c-11.302-.02-26.437.041-34.339.102-2.435 0-4.776.738-6.836 2.03-8.99 5.81-14.797 10.052-15.734 11.251-1.31 1.845-7.773 12.543-4.495 40.857 1.218 10.79 3.465 18.261 4.683 21.858.843 2.398 1.123 4.888 1.03 7.47-.094 2.952.187 8.393.655 14.665l.033.53c.931 15.126 2.079 33.762-1.531 40.235-6.181 10.975-8.897 31.542-7.867 61.239.79 24.183-.474 45.535-.638 48.302l-.017.302v.185c-.375 1.844-.562 7.47-.75 13.373l-.1 2.872c-.234 6.87-.46 13.432-1.117 15.942-.986 3.722-.314 17.167-.071 22.031.034.68.06 1.193.071 1.487l.42.671c1.152 1.834 3.796 6.046 6.23 10.12l-2.717-11.252 7.024 19.091c1.499 3.413 13.673 8.393 21.353 10.883.421-.207.526-.415.592-.544a.382.382 0 0 1 .063-.101c.281-1.015-1.124-2.952-2.154-4.151l-.28-.092-11.145-5.902-2.248-15.495c-.28-1.937.281-3.873 1.686-5.349l3.933-4.427.843.461c.187.092 1.78 1.107 2.997 3.413.419.825.538 2.092.692 3.737l.057.597c.187 3.321.562 7.932 2.81 11.621 1.03 1.66 2.528 2.582 4.308 2.767 1.966.184 3.652-.553 4.027-.922.187-.646-.469-3.228-1.686-5.257-1.311-2.214-3.372-15.126-3.746-17.708v-.185l.093-.184c1.405-5.257-1.404-14.111-3.465-19.183h-.187v-.277c-.562-1.384-1.03-2.398-1.405-3.044-1.217-2.305-5.244-8.854-6.93-11.528-.843-1.384-1.217-3.044-1.03-4.612 1.311-9.868 4.776-21.95 8.803-35.876 6.088-20.844 12.924-44.546 14.984-69.448 1.271-15.431.473-56.358.17-71.89-.032-1.641-.058-3-.076-4.013-4.214-5.995-6.087-19.737-6.087-19.737l.749-15.31 1.217 12.174.843-1.383a30.29 30.29 0 0 1 2.529-3.505c-.75 1.199-2.06 7.101-1.78 9.223.043.292.094.78.16 1.411.37 3.55 1.215 11.638 3.68 15.005 0 0 13.018 15.402 19.198 16.417.843.184 1.873.184 3.091.184 1.668 0 3.623-.128 5.758-.351l.156 2.231c-2.129.212-4.103.334-5.82.334-1.312 0-2.529-.092-3.465-.185-6.088-1.014-12.55-7.101-17.794-13.465.094 3.136.187 7.655.281 12.82.758 5.392 6.517 48.389 7.667 58.525l-2.159 1.02c-.524-4.829-2.829-22.461-5.134-39.809.188 15.495.094 32.004-.655 40.673-2.044 24.887-8.881 48.504-14.933 69.409l-.145.5-.014.05c-4.021 13.813-7.48 25.693-8.79 35.458-.186 1.106.094 2.213.657 3.135.366.602.784 1.286 1.231 2.018 1.842 3.014 4.175 6.831 5.395 8.957 1.087 2.004 1.813 3.607 2.088 4.283l-.005.052c2.06 5.165 4.963 14.111 3.559 20.106.936 5.81 2.622 15.31 3.371 16.693 1.03 1.66 2.81 5.811 1.686 7.655-.656 1.107-3.184 2.029-5.432 2.029h-.093c-1.012 0-1.872-.149-2.717-.448-1.165-.491-2.126-1.224-2.702-1.756a9.848 9.848 0 0 1-1.324-1.669c-2.518-3.986-2.877-8.651-3.15-12.2l-.035-.436c-.093-1.475-.187-2.951-.468-3.504-.468-.83-.936-1.476-1.404-1.845l-2.623 2.859c-.843 1.015-1.31 2.306-1.124 3.505l1.124 7.931 8.697 5.943 1.46 1.134a6.19 6.19 0 0 1 2.123 3.079l.052.171a5.51 5.51 0 0 1 .11 2.804l-1.673-1.417-.608-.971a9.996 9.996 0 0 0-2.807-2.932l-6.792-4.675.468 3.413 8.335 4.427v-.007l2.243 1.191.005.001v.013l.094.093.091.104c.73.828 3.344 3.796 2.718 6.259-.187.738-.75 1.845-2.435 2.398l-.372.092-.017-.003Z'
          />
          <path
            stroke='#3455FC'
            strokeDasharray='2 6'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit={10}
            strokeWidth={2.5}
            d='M88.797 15.014c6.938 1.57 20.288 10.444 16.361 30.472-3.927 20.029-21.763 24.508-42.673 24.508'
          />
          <circle
            cx={84.996}
            cy={149.178}
            r={16.863}
            stroke='#3455FC'
            strokeDasharray='2 6'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit={10}
            strokeWidth={2.5}
          />
          <circle
            cx={67.134}
            cy={273.876}
            r={11.186}
            stroke='#3455FC'
            strokeDasharray='2 6'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit={10}
            strokeWidth={2.5}
          />
        </g>
        <path
          stroke='#3455FC'
          strokeLinecap='round'
          strokeWidth={1.5}
          d='M156.66 106.019h-74M129.001 201.237h-54M38.5 150h44M27.5 41.14h54M24 273.488h44'
        />

        <BodySelectButton
          id='o-arm-lt-upper'
          selectedKeys={selectedKeys}
          cx={156.66}
          cy={106.019}
          r={12}
          d='M152.662 106.019h8M156.66 102.019v8'
        />

        <BodySelectButton
          id='o-arm-lt-lower'
          selectedKeys={selectedKeys}
          cx={129.001}
          cy={201.237}
          r={12}
          d='M125.003 201.237h8M129.001 197.238v8'
        />

        <BodySelectButton
          id='o-elbow-lt'
          selectedKeys={selectedKeys}
          cx={12}
          cy={12}
          r={12}
          d='M42.498 150h-8M38.5 146v8'
          transform='matrix(-1 0 0 1 50.5 138)'
        />

        <BodySelectButton
          id='o-shoulder-lt'
          selectedKeys={selectedKeys}
          cx={12}
          cy={12}
          r={12}
          d='M35.498 41.14h-8M31.5 37.14v8'
          transform='matrix(-1 0 0 1 43.5 29.14)'
        />

        <BodySelectButton
          id='o-wrist-lt'
          selectedKeys={selectedKeys}
          cx={12}
          cy={12}
          r={12}
          d='M27.998 273.488h-8M24 269.488v8'
          transform='matrix(-1 0 0 1 36 261.488)'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='#fff' d='M0 0h183v351H0z' />
        </clipPath>
        <clipPath id='b'>
          <path fill='#fff' d='M53 1h77v353H53z' />
        </clipPath>
      </defs>
    </svg>
  );
};
export default LeftArmMaleButtons;
